declare var swal: any;

import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';


import { ActorService } from '../../../../../services/actor.service';
import { DBOperation } from '../../../../../enums/enum';

import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { HCPService } from '../../../../../services/hcp.service';
import { ActorEmpHistoryInfoRequest, ActorEmpHistoryInfoController } from '../../../../../models/profileinfo/profileinfo.model';
import { NgbEmployeeHistoryInfoModal } from '../../employeehistoryinfo/modals/employeehistoryinfo.modal';
import { NgbActorDocsModal } from '../../modals/actordocs/actordocs.modal';
import { CustomDateTimeService } from '../../../../../services/datetime.service';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';

@Component({
  selector: 'employeehistoryinfov2',
  templateUrl: './employeehistoryinfov2.component.html',
  styleUrls: ['./employeehistoryinfov2.component.scss']
})

export class EmployeeHistoryInfoV2Component implements OnInit {
  @Input() ActorCode: number;
  @Input() ActorType: number;

  @Input() CanEdit: number;
  @Input() CanShow: number;

  CurrentActorEmpHistoryInfoRequest: ActorEmpHistoryInfoRequest;
  CurrentActorEmpHistoryInfoController: ActorEmpHistoryInfoController[];

  //
  CurrentActorEditEmpHistoryInfoRequest: ActorEmpHistoryInfoRequest;
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;

  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;

  //public MaxDateV = new Date();
  //public CanAdjustgetTimezoneOffset: boolean;
  //public MinDateV = new Date();

  public MaxDateV = new Date();
  public CanAdjustgetTimezoneOffset: boolean;
  public MinDateV = new Date();



  ValidTo: NgbDateStruct;
  ValidFrom: NgbDateStruct;



  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService,
    private modalService: NgbModal, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService) { }


  ngOnInit() {

    this.MinDateV.setFullYear(this.MinDateV.getFullYear() - 80);
    this.maxDate = { year: this.MaxDateV.getFullYear(), month: this.MaxDateV.getMonth() + 1, day: this.MaxDateV.getDate() };
    this.minDate = { year: this.MinDateV.getFullYear(), month: this.MinDateV.getMonth() + 1, day: this.MinDateV.getDate() };


    this.CanAdjustgetTimezoneOffset = AppData.CanAdjustgetTimezoneOffset;

    this.isNew = true;
    this.isEdit = false;
    this.CurrentActorEmpHistoryInfoRequest = new ActorEmpHistoryInfoRequest();
    this.CurrentActorEmpHistoryInfoController = new Array<ActorEmpHistoryInfoController>();
    this.CurrentActorEmpHistoryInfoRequest.ActorCode = this.ActorCode;

    this.CurrentActorEmpHistoryInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentActorEditEmpHistoryInfoRequest = new ActorEmpHistoryInfoRequest();
    this.CurrentActorEditEmpHistoryInfoRequest.ActorCode = this.ActorCode;

    this.CurrentActorEditEmpHistoryInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    if (this.CanShow === 1) {
      this.GetActorEmpHistoryInfoController();
    }

  }
  clearData2() {
    this.ValidFrom = null;
    this.ValidTo = null;
    this.isNew = true;
    this.isEdit = false;
    this.CurrentActorEmpHistoryInfoRequest = null;
    this.CurrentActorEmpHistoryInfoRequest = new ActorEmpHistoryInfoRequest();
    this.CurrentActorEditEmpHistoryInfoRequest.ConditionalOperator = 1;
    this.CurrentActorEmpHistoryInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorEmpHistoryInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;


  }
  clearData() {
    this.ValidFrom = null;
    this.ValidTo = null;
    this.isNew = true;
    this.isEdit = false;
    this.CurrentActorEmpHistoryInfoRequest = null;
    this.CurrentActorEmpHistoryInfoRequest = new ActorEmpHistoryInfoRequest();
    this.CurrentActorEditEmpHistoryInfoRequest.ConditionalOperator = 1;
    this.CurrentActorEmpHistoryInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorEmpHistoryInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ShowList = false;


  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }

  public onInputValidFrom(value: Date): void {

    this.CurrentActorEditEmpHistoryInfoRequest.FromDate = value;
  }
  public onInputValidTo(value: Date): void {

    this.CurrentActorEditEmpHistoryInfoRequest.ToDate = value;
  }

  GetActorEmpHistoryInfoController() {
    this.StartRefreshing();
    this.hcpservice.GetActorEmpHistoryInfoController(this.CurrentActorEmpHistoryInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentActorEmpHistoryInfoController = this.ApiResData.Result;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  onSubmit() {
    if (this.ShowList) {

      return;
    }
    else {
      //  alert("not showing list, proceed to savve...");
    }
    console.log('..................' + this.CurrentActorEmpHistoryInfoRequest.IsCurrent);
    this.StartRefreshing();
    this.CurrentActorEmpHistoryInfoRequest.ConditionalOperator = 1;
    //if (this.CanAdjustgetTimezoneOffset === true) {
    //  this.CurrentActorEmpHistoryInfoRequest.FromDate = this.customdatetimeservice.converToLocalTime(this.CurrentActorEmpHistoryInfoRequest.FromDate);
    //  this.CurrentActorEmpHistoryInfoRequest.ToDate = this.customdatetimeservice.converToLocalTime(this.CurrentActorEmpHistoryInfoRequest.ToDate);
    //}
    if (this.ValidFrom != null) {



      this.CurrentActorEmpHistoryInfoRequest.FromDate = new Date(this.parserFormatter.format(this.ValidFrom));;
    }
    if (this.ValidTo != null) {



      this.CurrentActorEmpHistoryInfoRequest.ToDate = new Date(this.parserFormatter.format(this.ValidTo));;
    }

    this.hcpservice.SaveActorEmpHistoryInfo(this.CurrentActorEmpHistoryInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorEmpHistoryInfoController();
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.ShowList = true;
            this.clearData2();

            


            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }
  ShowList: boolean = true;
  CancelUpdateOperation() {
    //alert("cancell upd op");
    this.ShowList = true;
  }
  CancelNewOperation() {
    //alert("cancell new op");
    this.ShowList = true;
  }

  edit_(EditCurrentActorEmpHistoryInfoController: ActorEmpHistoryInfoController) {
    this.ShowList = false;
    this.IsExpand = true;
    console.log('..................' + EditCurrentActorEmpHistoryInfoController.IsCurrent);
    this.IsExpand = true;
    this.CurrentActorEditEmpHistoryInfoRequest.ConditionalOperator = 2;
    this.CurrentActorEditEmpHistoryInfoRequest.EmpHistoryCode = EditCurrentActorEmpHistoryInfoController.EmpHistoryCode;
    this.CurrentActorEditEmpHistoryInfoRequest.ActorCode = EditCurrentActorEmpHistoryInfoController.ActorCode;
    this.CurrentActorEditEmpHistoryInfoRequest.EmployerName = EditCurrentActorEmpHistoryInfoController.EmployerName;
    this.CurrentActorEditEmpHistoryInfoRequest.SupervisorName = EditCurrentActorEmpHistoryInfoController.SupervisorName;
    this.CurrentActorEditEmpHistoryInfoRequest.SupervisorTitle = EditCurrentActorEmpHistoryInfoController.SupervisorTitle;
    this.CurrentActorEditEmpHistoryInfoRequest.Address = EditCurrentActorEmpHistoryInfoController.Address;
    this.CurrentActorEditEmpHistoryInfoRequest.PhoneNo = EditCurrentActorEmpHistoryInfoController.PhoneNo;
    this.CurrentActorEditEmpHistoryInfoRequest.MayContact = EditCurrentActorEmpHistoryInfoController.MayContact;
    this.CurrentActorEditEmpHistoryInfoRequest.FromDate = EditCurrentActorEmpHistoryInfoController.FromDate;
    this.CurrentActorEditEmpHistoryInfoRequest.ToDate = EditCurrentActorEmpHistoryInfoController.ToDate;
   

    if (this.CurrentActorEditEmpHistoryInfoRequest.FromDate != null) {
      var SValidFrom = new Date(this.CurrentActorEditEmpHistoryInfoRequest.FromDate);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.ValidFrom >1990');
        this.ValidFrom = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }


    if (this.CurrentActorEditEmpHistoryInfoRequest.ToDate != null) {
      var SValidTo = new Date(this.CurrentActorEditEmpHistoryInfoRequest.ToDate);
      if (SValidTo.getFullYear() > 1900) {
        console.log('this.ValidFrom >1990');
        this.ValidTo = {

          year: SValidTo.getFullYear(),
          month: SValidTo.getMonth() + 1,
          day: SValidTo.getDate()
        }
      }
    }

    this.CurrentActorEditEmpHistoryInfoRequest.Duties = EditCurrentActorEmpHistoryInfoController.Duties;
    this.CurrentActorEditEmpHistoryInfoRequest.Responsibilities = EditCurrentActorEmpHistoryInfoController.Responsibilities;

    this.CurrentActorEditEmpHistoryInfoRequest.ReasonForLeaving = EditCurrentActorEmpHistoryInfoController.ReasonForLeaving;
    this.CurrentActorEditEmpHistoryInfoRequest.IsCurrent = EditCurrentActorEmpHistoryInfoController.IsCurrent;
    

    this.isNew = false;
    this.isEdit = true;


  }
  onEditSubmit() {
    if (this.ShowList)
      return;
    console.log('..................' + this.CurrentActorEditEmpHistoryInfoRequest.IsCurrent);
    //if (this.CanAdjustgetTimezoneOffset === true) {
    //  this.CurrentActorEditEmpHistoryInfoRequest.FromDate = this.customdatetimeservice.converToLocalTime(this.CurrentActorEditEmpHistoryInfoRequest.FromDate);
    //  this.CurrentActorEditEmpHistoryInfoRequest.ToDate = this.customdatetimeservice.converToLocalTime(this.CurrentActorEditEmpHistoryInfoRequest.ToDate);
    //}
    if (this.ValidFrom != null) {



      this.CurrentActorEditEmpHistoryInfoRequest.FromDate = new Date(this.parserFormatter.format(this.ValidFrom));;
    }
    if (this.ValidTo != null) {



      this.CurrentActorEditEmpHistoryInfoRequest.ToDate = new Date(this.parserFormatter.format(this.ValidTo));;
    }
    this.StartRefreshing();
    this.CurrentActorEditEmpHistoryInfoRequest.ConditionalOperator = 2;
    this.hcpservice.SaveActorEmpHistoryInfo(this.CurrentActorEditEmpHistoryInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorEmpHistoryInfoController();
            //alertFunctions.AlertParam('Update Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Updated Successfully.....!');
            this.ShowList = true;
            this.clearData2();

            


            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }





  del_(EmpHistoryCode: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentities(EmpHistoryCode);
     // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentities(EmpHistoryCode: any) {


    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorEmpHistoryInfoRequest.ConditionalOperator = 3;
    this.CurrentActorEmpHistoryInfoRequest.EmpHistoryCode = EmpHistoryCode;
    this.hcpservice.SaveActorEmpHistoryInfo(this.CurrentActorEmpHistoryInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            this.ShowList = true;



            this.stopRefreshing();
            this.GetActorEmpHistoryInfoController();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }


  openDocContent(ActorDocCode: any) {
    if (ActorDocCode > 0) {
      let options: NgbModalOptions = {
        size: 'lg'
      };
      const modalRef = this.modalService.open(NgbActorDocsModal, options)//.result(result => { this.GetActorProfileController();});
      modalRef.componentInstance.ActorDocCode = ActorDocCode;
      modalRef.componentInstance.CanEdit = this.CanEdit;
      modalRef.componentInstance.CanShow = this.CanShow;
      //modalRef.result.then(x => { this.GetActorIdentitiesController() })
    }
    else {
      alertFunctions.AlertParam('No permission to Upload Doc For this Record...!');
    }
  }






  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
